import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { map, catchError, Observable, throwError } from 'rxjs';
import { CookieService, CookieOptions } from 'ngx-cookie';
import { Router } from '@angular/router';

import { LogService } from '@shared/services/core/log.service';

import { AuthAPIResponse } from '@shared/models/auth.interface';
import { SessionService } from '@shared/services/auth/session.service';
import { ExtendedLogDetails } from '@shared/models/log.interface';
import { UserInfoService } from '@shared/services/auth/user-info.service';
import { BusinessError } from '@modules/error/classes';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SKIP_LOGGING_ON_FAILURE } from '@core/tokens/meta-data.token';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private cookieOptions = {} as CookieOptions
  constructor(
    private logService: LogService,
    private sessionService: SessionService,
    private userInfoService: UserInfoService,
    private cookieService: CookieService,
    private router: Router,
    private deviceDetectorService: DeviceDetectorService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error, source) => { 
        console.log('(Error Interceptor) Error Name:');
        console.log(error.name);
        console.log('(Error Interceptor) Error Message:');
        console.log(error.message);
        console.log('(Error Interceptor) Error Stack:');
        console.log(error.stack);
        if(error.status === 401) {
          this.userInfoService.logoutUser();
          this.removeKeepMeLoggedIN();
          this.router.navigateByUrl('/login?se=1');
          //return throwError(() => new Error((error as HttpErrorResponse).statusText));
        }
        this.registerLog(request, error);
        return throwError(() => new Error((error as HttpErrorResponse).statusText))
      }),
      map(response => this.checkForAuthErrorResponse(request, response))
    );
  }

  checkForAuthErrorResponse(request: HttpRequest<unknown>, event: HttpEvent<unknown>) {
    const responseBody = (event as HttpResponse<AuthAPIResponse<any>>).body;
    console.log('(Error Interceptor) response body:');
    console.log(responseBody);
    console.log(event);
    if (event instanceof HttpResponse && responseBody!.httpStatusCode === 401) {
      this.registerLog(request, event);
      throw Error('Unauthorized');
    }

    if (event instanceof HttpResponse && responseBody!.httpStatusCode === 400) {
      const skipLogging = request.context.get(SKIP_LOGGING_ON_FAILURE);
      if (!skipLogging) this.registerLog(request, event);

      if (responseBody?.message.slice(0, 4) === '-100') throw new BusinessError("LOGIN_ERROR", 'Incorrect User Credentials.');
      else if (responseBody?.message.slice(0, 4) === '-200') throw new BusinessError('USER_INACTIVE', 'User is deactivated.');
      else if (responseBody?.message.slice(0, 4) === '-300') throw new BusinessError("LOGIN_ERROR", 'Incorrect User Credentials.');
      else if (responseBody?.message.slice(0, 4) === '-400') throw new BusinessError("INVALID_ACCESSCODE", 'Invalid Access Code.');
      else if (responseBody?.message.slice(0, 4) === '-604') throw new BusinessError("ADMIN_TYPE_LOCATION_DOES_NOT_HAVE_CHILDS", 'Invalid Client Type.');
      else throw Error('Unauthorized');
    }

    return event;
  }

  registerLog(request : HttpRequest<unknown>, response: HttpEvent<unknown>) {
    const jti = this.sessionService.getJTIFromCurrentRoute();
    const token = this.sessionService.getToken(jti);

    const user_id = this.userInfoService.isUserTypeClient() ? this.userInfoService.getClientInfo()?.ClientID : this.userInfoService.getProfessionalInfo()?.ProfessionalID;
    const extendedLogDetails: ExtendedLogDetails = { jti, user_id, request_endpoint: request.url, response_data: JSON.stringify(response) };

    const onMobileDevices = this.deviceDetectorService.isMobile() || this.deviceDetectorService.isTablet();
    this.logService.error('(API Calling Failed)', extendedLogDetails, onMobileDevices, token || undefined, jti);
  }

  removeKeepMeLoggedIN() {
    let jti: string = this.router.url.split('/')[2];
    if(this.cookieService.hasKey(this.encodeBase64(jti)) === true) {
      let date: Date = new Date();

      this.cookieOptions.expires = date;
      this.cookieOptions.domain = window.location.hostname;
      this.cookieOptions.secure = true;
      this.cookieOptions.sameSite = 'lax';  
      this.cookieOptions.storeUnencoded = true;

      this.cookieService.remove(this.encodeBase64(jti), this.cookieOptions);
    }
    if(this.cookieService.hasKey(this.encodeBase64(jti + ":temp")) === true) {
      let date: Date = new Date();

      this.cookieOptions.expires = date;
      this.cookieOptions.domain = window.location.hostname;
      this.cookieOptions.secure = true;
      this.cookieOptions.sameSite = 'lax';
      this.cookieOptions.storeUnencoded = true;

      this.cookieService.remove(this.encodeBase64(jti + ":temp"), this.cookieOptions);
    }
  }

  private encodeBase64 = (data: any) => {
    return Buffer.from(data).toString('base64');
  }
  private decodeBase64 = (data: any) => {
    return Buffer.from(data, 'base64').toString('ascii');
  }
}
